import { LogLevel } from './log-level.model';

export class LoggerConfig {
    level?: LogLevel;
}
